import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.finestyle');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-finestyle',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.finestyle/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.finestyle-page {
  position: relative;
  isolation: isolate;
  min-height: 100svh;
  overflow: hidden;
  background: #f3f0ea;
}

.style-glow {
  position: absolute;
  z-index: -2;
  right: -220px;
  bottom: -330px;
  width: 760px;
  height: 760px;
  border-radius: 9999px;
  background: radial-gradient(circle, rgba(190, 18, 60, 0.1), transparent 68%);
}

.editorial-number {
  position: absolute;
  z-index: -1;
  top: 12%;
  right: 4%;
  color: rgba(41, 37, 36, 0.035);
  font-size: min(38vw, 520px);
  font-weight: 800;
  line-height: 1;
  letter-spacing: -0.12em;
  user-select: none;
}

.style-mark {
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  color: #fff;
  border-radius: 9999px;
  background: #9f1239;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.05em;
}

.lookbook {
  perspective: 1000px;
}

.lookbook-card {
  position: absolute;
  border-radius: 2px;
  box-shadow: 0 28px 70px rgba(41, 37, 36, 0.14);
}

.card-back {
  inset: 10% 7% 2% 18%;
  border: 1px solid rgba(120, 113, 108, 0.18);
  background: #d6d3d1;
  transform: rotate(7deg);
}

.card-main {
  display: flex;
  inset: 2% 17% 9% 4%;
  flex-direction: column;
  justify-content: space-between;
  padding: 34px;
  color: white;
  background: linear-gradient(160deg, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.36)), linear-gradient(145deg, #be123c, #7f1d1d);
  transform: rotate(-4deg);
}

.card-label {
  display: flex;
  flex-direction: column;
  font-size: 30px;
  font-weight: 700;
  line-height: 0.9;
  letter-spacing: -0.04em;
}

.card-line {
  width: 48px;
  height: 1px;
  margin-top: auto;
  margin-bottom: 14px;
  background: rgba(255, 255, 255, 0.65);
}

.card-main p {
  font-size: 11px;
  letter-spacing: 0.24em;
}

.fabric-swatch {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 98px;
  height: 98px;
  border: 7px solid #f3f0ea;
  border-radius: 9999px;
  background: repeating-linear-gradient(45deg, #1c1917 0, #1c1917 4px, #44403c 4px, #44403c 8px);
  box-shadow: 0 18px 45px rgba(41, 37, 36, 0.18);
}

.lookbook-dot {
  position: absolute;
  top: 2%;
  right: 9%;
  width: 12px;
  height: 12px;
  border-radius: 9999px;
  background: #9f1239;
  box-shadow: 0 0 0 8px rgba(159, 18, 57, 0.1);
  animation: style-pulse 2.5s ease-in-out infinite;
}

@keyframes style-pulse {
  50% {
    box-shadow: 0 0 0 14px rgba(159, 18, 57, 0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .lookbook-dot {
    animation: none;
  }
}`],
})
export class PageFinestyleComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public navigateHome(event?: MouseEvent) {
        if (!event || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
            return;
        }

        event.preventDefault();
        this.service.href('/');
    }
}

export default PageFinestyleComponent;